import { ReactNode } from 'react'

/**
 * Class name registered as a "Mask" selector in Clarity
 * (Settings > Masking > Mask by element)
 */
export const personalInfoClassName = 'personal-info'

export const PersonalInfo = ({ children }: { children: ReactNode }) => (
  <span className={personalInfoClassName} style={{ display: 'contents' }} children={children} />
)
